import { useCallback } from "react"

import type { TranslationObj as ITranslationModel } from "$/utils/lang"

import { type TUserState, useUser } from "@/3514/hooks"

type TGetValueFromTranslatedObjectFunction = <T extends ITranslationModel>(obj: T) => string

/**
 * @return Returns a function for taking translation from Translation object
 */
function useGetValueFromTranslatedObject(): TGetValueFromTranslatedObjectFunction {
    const { user }: TUserState = useUser()

    return useCallback(
        <T extends ITranslationModel>(obj: T): string => obj?.[user?.languageCode] ?? obj?.en ?? String(),
        [user?.languageCode]
    )
}

export { useGetValueFromTranslatedObject, type TGetValueFromTranslatedObjectFunction }
